import React, { useRef, useEffect } from 'react';
import './Reviews.css';

const reviewsData = [
  {
    name: 'Steffen S.',
    role: 'Privatkunde',
    review: 'Die Arbeit war detailgetreu und professionell. Nichts auszusetzen. Gerne wieder!',
    stars: 5,
  },
  {
    name: 'Otto',
    role: 'Stammkunde',
    review: 'Auf individuelle Wünsche wurde Rücksicht genommen und das Team strahlt nicht zuletzt wegen des Charakters. Ich kann diesen Dienstleister jedem weiterempfehlen, der professionelle und engagierte Arbeit schätzt.',
    stars: 5,
  },
  {
    name: 'Piotr Kowalski',
    role: 'Gewerbekunde',
    review: 'Top Jungs mit dem Fokus auf das Wichtige. Schnell & zuverlässig und vor allem souverän im Auftreten.',
    stars: 5,
  },
];

function Stars({ count }) {
  return (
    <div className="rvw-stars" aria-label={`${count} von 5 Sternen`}>
      {Array.from({ length: 5 }).map((_, i) => (
        <span key={i} className={i < count ? 'rvw-star active' : 'rvw-star'}>★</span>
      ))}
    </div>
  );
}

export default function Reviews() {
  const rootRef = useRef(null);

  useEffect(() => {
    if (!rootRef.current) return;
    const cards = rootRef.current.querySelectorAll('.rvw-card');
    const obs = new IntersectionObserver(
      entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('rvw-visible'); }),
      { threshold: 0.15 }
    );
    cards.forEach(c => obs.observe(c));
    return () => obs.disconnect();
  }, []);

  return (
    <section id="bewertungen" className="rvw-root">

      {/* Background texture layer */}
      <div className="rvw-bg" aria-hidden />

      {/* Header */}
      <div className="rvw-header">
        <span className="rvw-eyebrow">Kundenstimmen</span>
        <h2 className="rvw-title">Was unsere Kunden<br /><em>über uns sagen</em></h2>
        <p className="rvw-subtitle">Kundenzufriedenheit ist unsere oberste Priorität.</p>
      </div>

      {/* Cards */}
      <div className="rvw-grid" ref={rootRef}>
        {reviewsData.map((r, i) => (
          <article
            key={i}
            className="rvw-card"
            style={{ transitionDelay: `${i * 140}ms` }}
          >
            {/* Large decorative quote */}
            <span className="rvw-quote" aria-hidden>❝</span>

            <Stars count={r.stars} />

            <p className="rvw-text">{r.review}</p>

            <footer className="rvw-footer">
              {/* Initials avatar */}
              <div className="rvw-avatar" aria-hidden>
                {r.name.charAt(0)}
              </div>
              <div>
                <p className="rvw-name">{r.name}</p>
                <p className="rvw-role">{r.role}</p>
              </div>
            </footer>
          </article>
        ))}
      </div>

      {/* Bottom trust bar */}
      

    </section>
  );
}